import * as React from "react";
const SvgErrorOutline = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M15.987 2.66663C8.62699 2.66663 2.66699 8.63996 2.66699 16C2.66699 23.36 8.62699 29.3333 15.987 29.3333C23.3603 29.3333 29.3337 23.36 29.3337 16C29.3337 8.63996 23.3603 2.66663 15.987 2.66663ZM17.3337 17.3333V9.33329H14.667V17.3333H17.3337ZM17.3337 22.6666V20H14.667V22.6666H17.3337ZM5.33366 16C5.33366 21.8933 10.107 26.6666 16.0003 26.6666C21.8937 26.6666 26.667 21.8933 26.667 16C26.667 10.1066 21.8937 5.33329 16.0003 5.33329C10.107 5.33329 5.33366 10.1066 5.33366 16Z",
	fill: "currentColor"
}));
export default SvgErrorOutline;
